import { Injectable, inject } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { TelefoneIdDataMensagem } from '../model/chat/telefone-id-data-mensagem.model';
import { MensagensPage } from '../model/chat/mensagens/mensagens-page.model';
import { MensagemKafkaEnvio } from '../model/chat/mensagens/mensagem-kafka-envio.model';
import { MensagemModel } from '../model/chat/mensagens/mensagem-model';
import { MensagemDetalhesModel } from '../model/chat/mensagens/mensagem-detalhes.model';
import { Contato } from '../model/contato/contato.model';
import { MensagemDetalhesBuscaModel } from '../model/chat/mensagens/mensagem-detalhes-busca.model';

@Injectable({
  providedIn: 'root',
})
export class MensagemService {
  private readonly http = inject(HttpClient);

  urlBase = `${environment.urlBase}/mensagem`;

  buscarMensagensContatoSelecionado(contato: Contato, noLoading: boolean, page: number ): Observable<MensagensPage> {
    const params = new HttpParams().set('page', page);
    const headers = new HttpHeaders().set('no-loading', `${noLoading}`);
    return this.http.post<MensagensPage>(
      `${this.urlBase}/lista-mensagens`, contato, {
        headers,
        params,
      }
    );
  }

  enviarMensagem(
    mensagem: MensagemModel,
    arquivo?: File,
    noLoading = false
  ): Observable<any> {
    const formData = new FormData();
    const kafkaTransitor: MensagemKafkaEnvio = new MensagemKafkaEnvio();
    kafkaTransitor.dados = mensagem;
    formData.append('dados', JSON.stringify(kafkaTransitor));
    if (arquivo) {
      formData.append('file', arquivo);
    }
    const headers = new HttpHeaders()
      .set('no-loading', `${noLoading}`)
      .set('hide-content-type', 'true');

    return this.http.post<any>(`${this.urlBase}/enviar-interno`, formData, {
      headers,
    });
  }

  reenviarMensagem(
    mensagemReenvio: TelefoneIdDataMensagem,
    noLoading: boolean
  ): Observable<any> {
    const headers = new HttpHeaders().set('no-loading', `${noLoading}`);
    return this.http.post<any>(`${this.urlBase}/reenviar`, mensagemReenvio, {
      headers,
    });
  }

  reagirMensagem(reacao: { contato: string; metaId: string; emoji: string; dataMensagem?: Date | string }): Observable<MensagemModel> {
    const headers = new HttpHeaders().set('no-loading', 'true');
    return this.http.post<MensagemModel>(`${this.urlBase}/reagir`, reacao, { headers });
  }

  buscarDetalhesMensagemPorId(mensagemDetalhesBuscaModel: MensagemDetalhesBuscaModel): Observable<MensagemDetalhesModel> {
    const headers = new HttpHeaders().set('no-loading', `${true}`);
    return this.http.post<MensagemDetalhesModel>(`${this.urlBase}/detalhes-mensagem`,mensagemDetalhesBuscaModel, {headers});
  }

}
